export default {
	MY_OPERATION_TASK_TABLE: 'MyOperationTaskTable',// backend cookie
	DASHBOARD_TASK_SLA_TABLE: 'DashboardTaskSlaTable',// backend cookie
	MY_OPERATION_TASK_TABLE_AVANCED_FILTER: 'MyOperationTaskTableAvancedFilter',// backend cookie
	DASHBOARD_TASK_SUMMARY_FILTER: 'DashboardTaskSummaryFilter',// backend cookie
  MY_OPERATION_DATES_FILTER: 'MyOperationDatesFilter',// backend cookie
  DOWNLOAD_EXPORT_TASK_COLUMNS: 'DownloadExportTaskColumns', // backend cookie
  UPDATE_TASK_PREFERENCE: 'UpdateTaskPreferences', // temporary cookie
};
